// services/api.js
// const API_URL = 'http://localhost:3001/api';
const API_URL = 'https://med-bot.dev-alb.ru/api';

class ApiService {
  // ============= КАТЕГОРИИ И ПОДКАТЕГОРИИ =============
  
  async getCategories() {
    try {
      const response = await fetch(`${API_URL}/categories`);
      if (!response.ok) throw new Error('Ошибка загрузки категорий');
      return await response.json();
    } catch (error) {
      console.error('API Error getCategories:', error);
      return [];
    }
  }

  async getSubcategories(categoryId) {
    try {
      const url = categoryId ? `${API_URL}/subcategories?category_id=${categoryId}` : `${API_URL}/subcategories`;
      const response = await fetch(url);
      if (!response.ok) throw new Error('Ошибка загрузки подкатегорий');
      return await response.json();
    } catch (error) {
      console.error('API Error getSubcategories:', error);
      return [];
    }
  }

  // ============= УСЛУГИ =============
  
  async getServices() {
    try {
      const response = await fetch(`${API_URL}/services`);
      if (!response.ok) throw new Error('Ошибка загрузки услуг');
      return await response.json();
    } catch (error) {
      console.error('API Error getServices:', error);
      return [];
    }
  }

  async getServicesBySubcategory(subcategoryId) {
    try {
      const response = await fetch(`${API_URL}/services?subcategory_id=${subcategoryId}`);
      if (!response.ok) throw new Error('Ошибка загрузки услуг');
      return await response.json();
    } catch (error) {
      console.error('API Error getServicesBySubcategory:', error);
      return [];
    }
  }

  async getServicesByCategory(categoryName) {
    try {
      const services = await this.getServices();
      return services.filter(s => s.category_name === categoryName);
    } catch (error) {
      console.error('API Error getServicesByCategory:', error);
      return [];
    }
  }

  async getServiceById(id) {
    try {
      const response = await fetch(`${API_URL}/services/${id}`);
      if (!response.ok) throw new Error('Ошибка загрузки услуги');
      return await response.json();
    } catch (error) {
      console.error('API Error getServiceById:', error);
      return null;
    }
  }

  async addService(data) {
    try {
      const response = await fetch(`${API_URL}/services`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      if (!response.ok) throw new Error('Ошибка добавления услуги');
      return await response.json();
    } catch (error) {
      console.error('API Error addService:', error);
      return null;
    }
  }

  async updateService(id, data) {
    try {
      const response = await fetch(`${API_URL}/services/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok;
    } catch (error) {
      console.error('API Error updateService:', error);
      return false;
    }
  }

  async deleteService(id) {
    try {
      const response = await fetch(`${API_URL}/services/${id}`, {
        method: 'DELETE'
      });
      return response.ok;
    } catch (error) {
      console.error('API Error deleteService:', error);
      return false;
    }
  }

  // ============= ВРАЧИ =============
  
  async getDoctors() {
    try {
      const response = await fetch(`${API_URL}/doctors`);
      if (!response.ok) throw new Error('Ошибка загрузки врачей');
      return await response.json();
    } catch (error) {
      console.error('API Error getDoctors:', error);
      return [];
    }
  }

  async getDoctorById(id) {
    try {
      const response = await fetch(`${API_URL}/doctors/${id}`);
      if (!response.ok) throw new Error('Ошибка загрузки врача');
      return await response.json();
    } catch (error) {
      console.error('API Error getDoctorById:', error);
      return null;
    }
  }

  async addDoctor(data) {
    try {
      const response = await fetch(`${API_URL}/doctors`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok ? await response.json() : null;
    } catch (error) {
      console.error('API Error addDoctor:', error);
      return null;
    }
  }

  async updateDoctor(id, data) {
    try {
      const response = await fetch(`${API_URL}/doctors/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok;
    } catch (error) {
      console.error('API Error updateDoctor:', error);
      return false;
    }
  }

  async deleteDoctor(id) {
    try {
      const response = await fetch(`${API_URL}/doctors/${id}`, {
        method: 'DELETE'
      });
      return response.ok;
    } catch (error) {
      console.error('API Error deleteDoctor:', error);
      return false;
    }
  }

  // Услуги врачей
  async getDoctorServices(doctorId) {
    try {
      const response = await fetch(`${API_URL}/doctor-services?doctor_id=${doctorId}`);
      if (!response.ok) throw new Error('Ошибка загрузки услуг врача');
      return await response.json();
    } catch (error) {
      console.error('API Error getDoctorServices:', error);
      return [];
    }
  }

  async addDoctorService(data) {
    try {
      const response = await fetch(`${API_URL}/doctor-services`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok ? await response.json() : null;
    } catch (error) {
      console.error('API Error addDoctorService:', error);
      return null;
    }
  }

  async updateDoctorService(id, data) {
    try {
      const response = await fetch(`${API_URL}/doctor-services/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok;
    } catch (error) {
      console.error('API Error updateDoctorService:', error);
      return false;
    }
  }

  async deleteDoctorService(id) {
    try {
      const response = await fetch(`${API_URL}/doctor-services/${id}`, {
        method: 'DELETE'
      });
      return response.ok;
    } catch (error) {
      console.error('API Error deleteDoctorService:', error);
      return false;
    }
  }

  // ============= КОРЗИНА =============
  
  async getCart(userId) {
    try {
      const response = await fetch(`${API_URL}/cart/${userId}`);
      if (!response.ok) throw new Error('Ошибка загрузки корзины');
      return await response.json();
    } catch (error) {
      console.error('API Error getCart:', error);
      return [];
    }
  }

  async addToCart(userId, serviceId, quantity = 1) {
    try {
      const response = await fetch(`${API_URL}/cart`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ user_id: userId, service_id: serviceId, quantity })
      });
      return response.ok;
    } catch (error) {
      console.error('API Error addToCart:', error);
      return false;
    }
  }

  async updateCartItem(itemId, quantity) {
    try {
      const response = await fetch(`${API_URL}/cart/${itemId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ quantity })
      });
      return response.ok;
    } catch (error) {
      console.error('API Error updateCartItem:', error);
      return false;
    }
  }

  async removeFromCart(itemId) {
    try {
      const response = await fetch(`${API_URL}/cart/${itemId}`, {
        method: 'DELETE'
      });
      return response.ok;
    } catch (error) {
      console.error('API Error removeFromCart:', error);
      return false;
    }
  }

  async clearCart(userId) {
    try {
      const response = await fetch(`${API_URL}/cart/clear/${userId}`, {
        method: 'DELETE'
      });
      return response.ok;
    } catch (error) {
      console.error('API Error clearCart:', error);
      return false;
    }
  }

  // ============= ПОЛЬЗОВАТЕЛИ =============
  
  async login(email, password) {
    try {
      const response = await fetch(`${API_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: email, password })
      });
      return await response.json();
    } catch (error) {
      console.error('API Error login:', error);
      return { success: false, error: 'Ошибка подключения' };
    }
  }

  async register(userData) {
    try {
      const response = await fetch(`${API_URL}/users/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(userData)
      });
      return await response.json();
    } catch (error) {
      console.error('API Error register:', error);
      return { error: 'Ошибка подключения' };
    }
  }

  async getUser(id) {
    try {
      const response = await fetch(`${API_URL}/users/${id}`);
      if (!response.ok) throw new Error('Ошибка загрузки пользователя');
      return await response.json();
    } catch (error) {
      console.error('API Error getUser:', error);
      return null;
    }
  }

  async updateUser(id, data) {
    try {
      const response = await fetch(`${API_URL}/users/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok;
    } catch (error) {
      console.error('API Error updateUser:', error);
      return false;
    }
  }

  // ============= НОВОСТИ =============
  
  async getNews(category = null, limit = null) {
    try {
      let url = `${API_URL}/news`;
      const params = [];
      if (category && category !== 'all') {
        params.push(`category=${category}`);
      }
      if (limit) {
        params.push(`limit=${limit}`);
      }
      if (params.length) {
        url += `?${params.join('&')}`;
      }
      const response = await fetch(url);
      if (!response.ok) throw new Error('Ошибка загрузки новостей');
      return await response.json();
    } catch (error) {
      console.error('API Error getNews:', error);
      return [];
    }
  }

  async getNewsById(id) {
    try {
      const response = await fetch(`${API_URL}/news/${id}`);
      if (!response.ok) throw new Error('Ошибка загрузки новости');
      return await response.json();
    } catch (error) {
      console.error('API Error getNewsById:', error);
      return null;
    }
  }

  async addNews(data) {
    try {
      const response = await fetch(`${API_URL}/news`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok ? await response.json() : null;
    } catch (error) {
      console.error('API Error addNews:', error);
      return null;
    }
  }

  async updateNews(id, data) {
    try {
      const response = await fetch(`${API_URL}/news/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok;
    } catch (error) {
      console.error('API Error updateNews:', error);
      return false;
    }
  }

  async deleteNews(id) {
    try {
      const response = await fetch(`${API_URL}/news/${id}`, {
        method: 'DELETE'
      });
      return response.ok;
    } catch (error) {
      console.error('API Error deleteNews:', error);
      return false;
    }
  }

  // ============= ОТЗЫВЫ =============
  
  async addReview(data) {
    try {
      const response = await fetch(`${API_URL}/reviews`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok ? await response.json() : null;
    } catch (error) {
      console.error('API Error addReview:', error);
      return null;
    }
  }

  async getReviews(doctorId = null, serviceId = null, status = null) {
    try {
      let url = `${API_URL}/reviews?`;
      const params = [];
      if (doctorId) params.push(`doctor_id=${doctorId}`);
      if (serviceId) params.push(`service_id=${serviceId}`);
      if (status) params.push(`status=${status}`);
      if (params.length) {
        url += params.join('&');
      }
      const response = await fetch(url);
      if (!response.ok) throw new Error('Ошибка загрузки отзывов');
      return await response.json();
    } catch (error) {
      console.error('API Error getReviews:', error);
      return [];
    }
  }

  async moderateReview(id, status, moderatedBy) {
    try {
      const response = await fetch(`${API_URL}/reviews/${id}/moderate`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status, moderated_by: moderatedBy })
      });
      return response.ok;
    } catch (error) {
      console.error('API Error moderateReview:', error);
      return false;
    }
  }

  // ============= ЗАПИСЬ К ВРАЧУ =============
  
  async getAppointments(params = {}) {
    try {
      let url = `${API_URL}/appointments?`;
      const queryParams = [];
      if (params.user_id) queryParams.push(`user_id=${params.user_id}`);
      if (params.doctor_id) queryParams.push(`doctor_id=${params.doctor_id}`);
      if (params.date) queryParams.push(`date=${params.date}`);
      if (params.status) queryParams.push(`status=${params.status}`);
      if (queryParams.length) {
        url += queryParams.join('&');
      }
      const response = await fetch(url);
      if (!response.ok) throw new Error('Ошибка загрузки записей');
      return await response.json();
    } catch (error) {
      console.error('API Error getAppointments:', error);
      return [];
    }
  }

  async addAppointment(data) {
    try {
      const response = await fetch(`${API_URL}/appointments`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok ? await response.json() : null;
    } catch (error) {
      console.error('API Error addAppointment:', error);
      return null;
    }
  }

  async updateAppointment(id, data) {
    try {
      const response = await fetch(`${API_URL}/appointments/${id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok;
    } catch (error) {
      console.error('API Error updateAppointment:', error);
      return false;
    }
  }

  async deleteAppointment(id) {
    try {
      const response = await fetch(`${API_URL}/appointments/${id}`, {
        method: 'DELETE'
      });
      return response.ok;
    } catch (error) {
      console.error('API Error deleteAppointment:', error);
      return false;
    }
  }

  // ============= НЕОТЛОЖНАЯ ПОМОЩЬ =============
  
  async getEmergencyContacts() {
    try {
      const response = await fetch(`${API_URL}/emergency`);
      if (!response.ok) throw new Error('Ошибка загрузки контактов');
      return await response.json();
    } catch (error) {
      console.error('API Error getEmergencyContacts:', error);
      return [];
    }
  }

  // ============= СТАТИСТИКА =============
  
  async getStats() {
    try {
      const response = await fetch(`${API_URL}/stats`);
      if (!response.ok) throw new Error('Ошибка загрузки статистики');
      return await response.json();
    } catch (error) {
      console.error('API Error getStats:', error);
      return {};
    }
  }

  // ============= ТЕХПОДДЕРЖКА =============
  
  async getSupportChats(userId) {
    try {
      const response = await fetch(`${API_URL}/support/chats/${userId}`);
      if (!response.ok) throw new Error('Ошибка загрузки чатов');
      return await response.json();
    } catch (error) {
      console.error('API Error getSupportChats:', error);
      return [];
    }
  }

  async createSupportChat(data) {
    try {
      const response = await fetch(`${API_URL}/support/chats`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok ? await response.json() : null;
    } catch (error) {
      console.error('API Error createSupportChat:', error);
      return null;
    }
  }

  async getSupportMessages(chatId) {
    try {
      const response = await fetch(`${API_URL}/support/chats/${chatId}/messages`);
      if (!response.ok) throw new Error('Ошибка загрузки сообщений');
      return await response.json();
    } catch (error) {
      console.error('API Error getSupportMessages:', error);
      return [];
    }
  }

  async sendSupportMessage(data) {
    try {
      const response = await fetch(`${API_URL}/support/messages`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok ? await response.json() : null;
    } catch (error) {
      console.error('API Error sendSupportMessage:', error);
      return null;
    }
  }

  async closeSupportChat(chatId) {
    try {
      const response = await fetch(`${API_URL}/support/chats/${chatId}/close`, {
        method: 'PUT'
      });
      return response.ok;
    } catch (error) {
      console.error('API Error closeSupportChat:', error);
      return false;
    }
  }

  // ============= ВСПОМОГАТЕЛЬНЫЕ МЕТОДЫ =============
  
  async getServicesByCategoryAndSubcategory(categoryName, subcategoryName) {
    try {
      const categories = await this.getCategories();
      const targetCategory = categories.find(c => c.name === categoryName);
      if (!targetCategory) return [];
      
      const subcategories = await this.getSubcategories(targetCategory.id);
      const targetSubcategory = subcategories.find(s => s.name === subcategoryName);
      if (!targetSubcategory) return [];
      
      return await this.getServicesBySubcategory(targetSubcategory.id);
    } catch (error) {
      console.error('API Error getServicesByCategoryAndSubcategory:', error);
      return [];
    }
  }

  async getRadiologyServices(subcategoryName) {
    return this.getServicesByCategoryAndSubcategory('Лучевая диагностика', subcategoryName);
  }

  async getLabServices(subcategoryName) {
    return this.getServicesByCategoryAndSubcategory('Лабораторная диагностика', subcategoryName);
  }

  async getCheckupServices(subcategoryName) {
    return this.getServicesByCategoryAndSubcategory('Check-up', subcategoryName);
  }

  // ============= ДОКУМЕНТЫ ПОЛЬЗОВАТЕЛЯ =============
  
  async getUserDocuments(userId) {
    try {
      const response = await fetch(`${API_URL}/users/${userId}/documents`);
      if (!response.ok) throw new Error('Ошибка загрузки документов');
      return await response.json();
    } catch (error) {
      console.error('API Error getUserDocuments:', error);
      return [];
    }
  }

  async addUserDocument(userId, data) {
    try {
      const response = await fetch(`${API_URL}/users/${userId}/documents`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok ? await response.json() : null;
    } catch (error) {
      console.error('API Error addUserDocument:', error);
      return null;
    }
  }

  async deleteUserDocument(userId, docId) {
    try {
      const response = await fetch(`${API_URL}/users/${userId}/documents/${docId}`, {
        method: 'DELETE'
      });
      return response.ok;
    } catch (error) {
      console.error('API Error deleteUserDocument:', error);
      return false;
    }
  }

  // ============= ПОКАЗАТЕЛИ ЗДОРОВЬЯ =============
  
  async getUserHealthMetrics(userId) {
    try {
      const response = await fetch(`${API_URL}/users/${userId}/health-metrics`);
      if (!response.ok) throw new Error('Ошибка загрузки показателей');
      return await response.json();
    } catch (error) {
      console.error('API Error getUserHealthMetrics:', error);
      return [];
    }
  }

  async addUserHealthMetric(userId, data) {
    try {
      const response = await fetch(`${API_URL}/users/${userId}/health-metrics`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok ? await response.json() : null;
    } catch (error) {
      console.error('API Error addUserHealthMetric:', error);
      return null;
    }
  }

  // ============= НАСТРОЙКИ ПОЛЬЗОВАТЕЛЯ =============
  
  async getUserSettings(userId) {
    try {
      const response = await fetch(`${API_URL}/users/${userId}/settings`);
      if (!response.ok) throw new Error('Ошибка загрузки настроек');
      return await response.json();
    } catch (error) {
      console.error('API Error getUserSettings:', error);
      return null;
    }
  }

  async updateUserSettings(userId, data) {
    try {
      const response = await fetch(`${API_URL}/users/${userId}/settings`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.ok;
    } catch (error) {
      console.error('API Error updateUserSettings:', error);
      return false;
    }
  }
}

export default new ApiService();